import { SegmentationGroup } from "../types/types";

interface ValidationParams {
  tableName: string | null;
  segmentGroups: SegmentationGroup[];
  count1Column: string | null;
  driver1Type: string | null;
  driver1Mode: string | null;
  driver1NumeratorType: string | null;
  driver2Type: string | null;
  driver2Mode: string | null;
  driver2NumeratorType: string | null;
}

/**
 * Validates driver and segment configuration
 * @param params - Object containing all necessary validation parameters
 * @returns boolean indicating if the configuration is valid
 */
export const validateDriversAndSegments = ({
  tableName,
  segmentGroups,
  count1Column,
  driver1Type,
  driver1Mode,
  driver1NumeratorType,
  driver2Type,
  driver2Mode,
  driver2NumeratorType,
}: ValidationParams): boolean => {
  return !(
    tableName &&
    segmentGroups.length > 0 &&
    segmentGroups.every((group) => group.type) &&
    count1Column &&
    ((driver1Type && driver1Mode === "COLUMN") ||
      (driver2Type && driver2Mode === "COLUMN") ||
      (driver1Type && driver1NumeratorType && driver1Mode === "PERCENTAGE") ||
      (driver2Type && driver2NumeratorType && driver2Mode === "PERCENTAGE")) &&
    (driver1Mode !== "PERCENTAGE" ||
      (driver1Type && driver1NumeratorType) ||
      (!driver1Type && !driver1NumeratorType)) &&
    (driver2Mode !== "PERCENTAGE" ||
      (driver2Type && driver2NumeratorType) ||
      (!driver2Type && !driver2NumeratorType)) &&
    !segmentGroups.some(
      (group) =>
        group.method === "MANUAL" &&
        (!group.segments ||
          group.segments.length === 0 ||
          group.segments.every((seg) => seg.minValue === undefined && seg.maxValue === undefined))
    )
  );
};
